<template>
  <div class="ad-list">
    <headerNotice routerName="副屏广告列表"></headerNotice>
    <div class="content">
      <!-- 搜索框 -->
      <div class="seach-box">
        <div class="title-wrapper">
          <h2 class="title">
            <i></i>
            <span>筛选查询</span>
          </h2>
        </div>
        <div class="input-wrapper">
          <div>
            <span>广告名称：</span>
            <el-input class="el-search" clearable v-model="adName" placeholder="广告名称"></el-input>
          </div>
          <div class="ad-pos-wrapper">
            <span>广告位置：</span>
            <el-select v-model="adPos" placeholder="全部">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <el-button class="search-btn" @click="toSearch">查询结果</el-button>
        </div>
      </div>
      <!-- 广告列表 -->
      <div class="advertise-lists">
        <div class="head">
          <h2 class="title">
            <i></i>
            <span>数据列表</span>
          </h2>
          <el-button @click="AddAd">添加广告</el-button>
        </div>
        <!-- 表格 -->
        <el-table
          v-loading="loading"
          ref="multipleTable"
          :data="adData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" prop="title" label="广告名称"></el-table-column>
          <el-table-column align="center" prop="adType" label="广告位置">
            <template slot-scope="scope">{{ scope.row.adType | typeFilter }}</template>
          </el-table-column>
          <el-table-column align="center" label="广告图片" width="120">
            <template slot-scope="scope">
              <img :src="baseUrl+ scope.row.imageUrl" width="100" height="100">
            </template>
          </el-table-column>
          <el-table-column align="center" prop="status" label="上线/下线">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-text="上线"
                inactive-text="下线"
                :active-value="1"
                @change="updateStatus(scope.row.advertID,scope.row.status)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="control" label="操作">
            <template slot-scope="scope">
              <el-button @click="toEdit(scope.row.advertID)" type="text" size="small">编辑</el-button>
              <el-button @click="setTop(scope.row.advertID)" type="text" size="small">置顶</el-button>
              <el-button @click="delAdItems([scope.row.advertID], 0)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btn-wrapper">
        <span>已选择{{multipleSelection.length}}条广告</span>
        <el-button @click="delAdItems(multipleSelection, 1)">批量删除</el-button>
      </div>
      <!-- 弹窗 -->
      <el-dialog width="600px" title="编辑广告" :visible.sync="showEdit">
        <adTemp ref='adTemp' @sendData='updateAd' :type='1' :data='adDetails' v-loading="loading"/>
      </el-dialog>
      <!-- 内容结束 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync='currentPage'
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
          center
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
import adTemp from "./adTemp1.vue";

export default {
  components: {
    headerNotice,
    adTemp
  },
  props: {},
  data() {
    return {
      baseUrl: this.$store.state.ossUrl,
      loading: false,
      pageSize: 10,
      totalCount: 0,
      currentPage: 1,
      adName: "",
      showEdit: false,
      adPos: 0,
      options: [
        { value: 0, label: "全部" },
        { value: 1, label: "活动入口" },
        { value: 2, label: "广告" }
      ],
      adData: [],
      adDetails: {},
      multipleSelection: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    //获取广告列表
    getList(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminAdvertising1/GetList",
        params: params,
        success(res) {
          // console.log(res);
          self.adData = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    dealImgUrl(data) {
      data.forEach(item => {
        item.imageUrl = this.$store.state.apiUrl + item.imageUrl;
      });
      // console.log(data)
      return data;
    },
    // 搜索
    toSearch() {
      // console.log(this.adPos,this.adName)
      this.getList({
        Title: this.adName,
        AdType: this.adPos,
        MaxResultCount: this.pageSize,
        SkipCount: 0
      });
      this.currentPage = 1;
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = [];
      val.forEach(item => {
        this.multipleSelection.push(item.advertID);
      });
    },
    // 切换广告状态
    updateStatus(id, status) {
      // console.log(id,status)
      let data = {
        advertID: id,
        status: status ? 1 : 2
      };
      let search = `?advertID=${data.advertID}&status=${data.status}`;
      let self = this;
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminAdvertising1/UpdateStatus" +
          search,
        data: data,
        success(res) {
          self.$message({
            showClose: true,
            message: "操作成功！",
            type: "success"
          });
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    // 置顶广告
    setTop(id) {
      let data = {
        advertID: id
      };
      let self = this;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminAdvertising1/SetTop?advertID=" +
          id,
        data: data,
        success(res) {
          self.$message({
            showClose: true,
            message: "操作成功！",
            type: "success"
          });
          self.getList({
            Title: self.adName,
            AdType: self.adPos,
            MaxResultCount: self.pageSize
          });
          self.currentPage = 1;
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    toEdit(id) {
      this.showEdit = !this.showEdit;
      this.getDetail({ advertID: id });
    },
    updateAd(form, type) {
      if (!type) {
        return;
      }
      // console.log(form)
      let self = this;
      let adTemp = self.$refs.adTemp;
      adTemp.loading = true;
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminAdvertising1/Update",
        data: form,
        success(res) {
          self.$message({
            showClose: true,
            message: "操作成功！",
            type: "success"
          });
          adTemp.loading = false;
          self.showEdit = false;
          self.getList({
            Title: self.adName,
            AdType: self.adPos,
            MaxResultCount: self.pageSize
          });
          self.currentPage = 1;
        },
        fail(res) {
          adTemp.loading = false;
        }
      });
    },
    getDetail(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminAdvertising1/GetDetail",
        params: params,
        success(res) {
          //  console.log(res)
          self.adDetails = res;
          // let arr = self.adDetails.link.match(/itemID=(\d+)/)
          // // console.log(arr)
          // if(arr) {
          //   self.adDetails.link = arr[1]
          // } else {
          //   self.adDetails.link = ''
          // }
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    // 删除
    delAdItems(id, type) {
      // console.log(id)
      if (type == 1 && !id.length) {
        this.$message.error("请至少勾选一项");
        return;
      }
      let data = {
        advertIDs: id
      };
      let search = id.map(item => {
        return "advertIDs=" + item;
      });
      search = "?" + search.join("&");
      let self = this;
      this.$confirm("此操作将删除选中的广告, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $http.DELETE({
            url:
              this.$store.state.apiUrl +
              "/api/services/app/AdminAdvertising1/Delete" +
              search,
            data: data,
            success(res) {
              self.$message({
                showClose: true,
                message: "操作成功！",
                type: "success"
              });
              self.getList({
                Title: self.adName,
                AdType: self.adPos,
                MaxResultCount: self.pageSize
              });
              self.currentPage = 1;
            },
            fail(res) {
              // self.loading = false;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    AddAd() {
      this.$router.push({ path: "/advertisement1" });
      // 还需要修改路由状态
    },
    // 分页--跳页
    handleCurrentChange(val) {
      let skipCount = (val - 1) * this.pageSize;
      this.getList({
        Title: this.adName,
        AdType: this.adPos,
        SkipCount: skipCount,
        MaxResultCount: this.pageSize
      });
    },
    // 分页--数据条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList({
        Title: this.adName,
        AdType: this.adPos,
        MaxResultCount: val
      });
    }
  },
  filters: {
    typeFilter(status) {
      return status == 1 ? "首页轮播" : "积分兑换轮播";
    }
  },
  created() {
    this.getList({
      MaxResultCount: this.pageSize
    });
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.ad-list {
  .content {
    padding: 0 50px;
  }
  // 搜索框
  .seach-box {
    border: 1px solid rgba(228, 228, 228, 1);
    margin: 20px 0;
    .title-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      background-color: rgba(243, 243, 243, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      padding: 0 20px;
    }
    .title {
      display: flex;
      align-items: center;
      font-weight: 400;
      // i:first-child {
      //   width: 18px;
      //   height: 18px;
      //   background: green;
      // }
    }
    .input-wrapper {
      display: flex;
      align-items: center;
      height: 60px;
      padding-left: 40px;
      .el-search {
        width: 180px;
      }
      .ad-pos-wrapper {
        margin-left: 40px;
        margin-right: 40px;
      }
    }
  }
  // 广告列表
  .advertise-lists {
    // margin: 0 50px;
    border: 1px solid rgba(228, 228, 228, 1);
    font-weight: 400;
    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 20px;
      background-color: rgba(243, 243, 243, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      .title {
        display: flex;
        align-items: center;
        height: 50px;
        font-weight: 400;
        padding-left: 20px;
        // i:first-child {
        //   width: 18px;
        //   height: 18px;
        //   background: green;
        // }
      }
    }
  }
  .btn-wrapper {
    padding: 20px 0 0 20px;
    span:first-child {
      margin-right: 20px;
    }
  }
  .pagination-wrapper {
    text-align: center;
    margin-top: 20px;
  }
}
</style>
